import axiosInstance from '@/axiosInstance';
import type { AxiosResponse } from 'axios';
import type { Organization } from './types';

export type { Organization } from './types';

export const OrganizationAPI = {
  async getOrganizations(): Promise<AxiosResponse<Organization[]>> {
    try {
      const response = await axiosInstance.get(`/api/Organization/`);
      console.log('Response:', response.data);
      return response;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  },
  async getOrganizationNames(): Promise<AxiosResponse<string[]>> {
    try {
      const response = await axiosInstance.get(`/api/Organization/GetOrgNames`);
      return response;
    } catch (error) {
      console.error('Error:', error);
      throw error;
    }
  },
  async updateOrganization(org: Organization): Promise<AxiosResponse<void>> {
    return axiosInstance.put(`/api/Organization`, org);
  },
  async getVendors(params: {
    eliCategory?: string | null;
    siteCode?: string | null;
    includeOrganizationId?: number | null;
  }): Promise<AxiosResponse<Organization[]>> {
    return axiosInstance.get(`/api/Organization/Vendors`, { params });
  },
  async getOrganizationCategories(organizationID: number): Promise<AxiosResponse<string[]>> {
    return axiosInstance.get(`/api/Organization/${organizationID}/Categories`);
  },
  async saveOrganizationCategories(
    organizationID: number,
    eliCategories: string[],
  ): Promise<AxiosResponse<string[]>> {
    return axiosInstance.put(`/api/Organization/${organizationID}/Categories`, eliCategories);
  },
  async getOrganizationSites(organizationID: number): Promise<AxiosResponse<string[]>> {
    return axiosInstance.get(`/api/Organization/${organizationID}/Sites`);
  },
  async saveOrganizationSites(
    organizationID: number,
    siteCodes: string[],
  ): Promise<AxiosResponse<string[]>> {
    return axiosInstance.put(`/api/Organization/${organizationID}/Sites`, siteCodes);
  },
};
